import React from 'react';

const NewsDetailPage = () => {
  return (
    <div style={{width: "100%", height: "70vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
      <h1>This Page is still under development</h1>
    </div>
  )
};

export default NewsDetailPage;